// extracted by mini-css-extract-plugin
export var dropdown = "_sn-0";
export var imageWrapper = "_sn-3";
export var itemNameContainer = "_sn-1";
export var productImage = "_sn-2";
export var spinnerWrapper = "_sn-4";